export const AUTH_V3_RESPONSE_SUCCESS_RESULT = 0;
export const AUTH_V3_NO_COOKIE_ERROR_RESULT = 12;
